import { mapGetters } from 'vuex'
import { parseHierarchicalObjects, skills, layeredSkillsByLv2CategoryMap } from '@/lib/parse'

/**
 * マッチングに関わる定数・処理をまとめたmixin
 */
export default {
  computed: {
    ...mapGetters([
      'skillsMaster',
      'hasChildCategorySkillBy'
    ]),
    age () {
      return (this.matching.age.min && this.matching.age.max)
        ? `${this.matching.age.min}歳 〜 ${this.matching.age.max}歳` : ''
    },
    address () {
      return this.createJoinedText(this.matching.addressList)
    },
    educationalBackground () {
      return this.matching.educationalBackground
        ? `${this.matching.educationalBackground}以上` : ''
    },
    graduate () {
      return (this.matching.graduateYear.min !== null && this.matching.graduateYear.max !== null)
        ? `${this.matching.graduateYear.min}年 〜 ${this.matching.graduateYear.max}年に卒業した会員` : ''
    },
    educationDepartment () {
      return this.matching.educationDepartmentList.join('、 ')
    },
    incomeRange () {
      return (this.matching.incomeRange.min !== null && this.matching.incomeRange.max !== null)
        ? `${this.matching.incomeRange.min}万円 〜 ${this.matching.incomeRange.max}万円` : ''
    },
    work () {
      // 共通コンポーネントを利用できる形式に整形
      return [
        {
          parentName: '就業状況',
          nameList: this.matching.workStatus ? [this.matching.workStatus] : []
        },
        {
          parentName: '現在の年収',
          nameList: this.incomeRange ? [this.incomeRange] : []
        },
        {
          parentName: '現在の就業形態',
          nameList: this.matching.employmentList.length ? [this.createJoinedText(this.matching.employmentList)] : []
        }
      ]
    },
    experiencedBusiness () {
      return this.createJoinedText(this.matching.experiencedBusinessNameList)
    },
    toeic () {
      return this.matching.toeicScore
        ? `${this.matching.toeicScore}点以上` : ''
    },
    toefl () {
      return this.matching.toeflScore
        ? `${this.matching.toeflScore}点以上` : ''
    },
    otherLanguage () {
      return this.createJoinedText(
        this.matching.languageSkillList.map(languageSkill => {
          return languageSkill.level
            ? `${languageSkill.name}(${languageSkill.level})` : languageSkill.name
        })
      )
    },
    skill () {
      // skillListの整形
      const parsedSkillsMaster = parseHierarchicalObjects(this.skillsMaster)
      const parsedSkills = skills(this.matching.skillList, parsedSkillsMaster)
      const skillMap = layeredSkillsByLv2CategoryMap(this.skillsMaster, parsedSkills, 'id')

      // スキルマスタ大項目分ForEach
      return this.skillsMaster.map(skillMaster => {
        // 中項目有無で分岐
        if (this.hasChildCategorySkillBy(skillMaster.id)) {
          // 中項目あり
          return skillMaster.children.map(lv2Master => {
            const lv2Skills = skillMap[skillMaster.id]
              .filter(lv2 => lv2[0] === `${lv2Master.id}`) // lv2[0]:中項目id
              .map(lv2 => lv2[1]).flat() // lv2[1]:中項目一覧

            return {
              parentName: lv2Master.name, // 中項目名
              nameList: lv2Skills.map(skillValue => this.formatSkill(skillValue))
            }
          })
        } else {
          // 中項目なし
          if (skillMap[skillMaster.id].length) {
            // 指定あり
            return skillMap[skillMaster.id][0][1]
              .map(skillValue => this.formatSkill(skillValue))
              .join('\n')
          } else {
            // 指定なし
            return '' // 子コンポーネントでの判定用に空文字を追加
          }
        }
      }).reduce((acc, value, index) => {
        // 大項目idをkeyとしたオブジェクトへ変換
        return { ...acc, [this.skillsMaster[index].id]: value }
      }, {})
    },
    license () {
      return this.createJoinedText(this.matching.licenseList)
    },
    occupations () {
      return this.matching.desiredOccupationList.map(desiredOccupation => {
        return {
          parentName: desiredOccupation.parentName,
          nameList: desiredOccupation.childList.map(child => {
            if (child.answerList.length) {
              return `${child.name}　(${child.answerList.join('、 ')})`
            } else {
              return child.name
            }
          })
        }
      })
    }
  },
  methods: {
    formatSkill (skillValue) {
      return `${skillValue.path[3].name}(${skillValue.yearLabel})`
    },
    createJoinedText (list) {
      return list.join('、 ')
    }
  }
}
